<template>
  <section class="login-shell">
    <div class="login-glow login-glow-left" />
    <div class="login-glow login-glow-right" />

    <div class="login-layout">
      <div class="login-brand">
        <p class="login-kicker">{{ branding.loginEyebrow }}</p>
        <h1 class="login-title">Control societario y financiero con enfoque estratégico.</h1>
        <p class="login-copy">{{ branding.loginCopy }}</p>
      </div>

      <form class="login-card" @submit.prevent="login">
        <div class="login-brand-stack">
          <figure v-if="branding.clientLogoUrl" class="login-client-logo">
            <img :alt="branding.clientName || 'Client logo'" :src="branding.clientLogoUrl">
          </figure>
          <figure v-else class="login-logo">
            <img alt="ODIN logo" src="../assets/logo.png">
          </figure>
          <p v-if="branding.clientName" class="login-client-name">{{ branding.clientName }}</p>
          <p class="login-powered-by">{{ branding.poweredByLabel }}</p>
        </div>

        <div class="login-card__header">
          <h2>Bienvenido</h2>
          <p>Introduce tus credenciales para acceder.</p>
        </div>

        <div class="field">
          <label class="label login-label" for="email">Usuario</label>
          <div class="control">
            <input
              id="email"
              v-model="email"
              class="input login-input"
              type="email"
              required
              placeholder="correo@empresa.com"
              autocomplete="username"
            >
          </div>
        </div>

        <div class="field">
          <label class="label login-label" for="password">Contraseña</label>
          <div class="control">
            <input
              id="password"
              v-model="password"
              class="input login-input"
              type="password"
              placeholder="••••••••"
              autocomplete="current-password"
            >
          </div>
        </div>

        <p v-if="error" class="login-error">{{ strError }}</p>

        <div class="field">
          <button class="button login-submit" type="submit">
            Entrar
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import auth from '@/auth/index'
import branding from '@/config/branding'

export default {
  data: () => ({
    email: '',
    password: '',
    error: false,
    strError: '',
    branding
  }),
  methods: {
    async login () {
      try {
        const result = await auth.login(this.email, this.password)
        auth.setUserLogged(result.data.user, result.data.token)
        this.$router.push('/')
      } catch (error) {
        this.strError = 'Has introducido mal el email o la contraseña.'
        this.error = true
      }
    }
  }
}
</script>

<style scoped>
.login-shell {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 2rem;
  background:
    radial-gradient(circle at top left, rgba(201, 169, 97, 0.18), transparent 30%),
    radial-gradient(circle at bottom right, rgba(255, 255, 255, 0.08), transparent 28%),
    linear-gradient(135deg, #f3efe7 0%, #e7dfd1 42%, #d8d0c3 100%);
}

.login-layout {
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 4rem);
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 430px);
  align-items: center;
  gap: 3rem;
  max-width: 1160px;
  margin: 0 auto;
}

.login-brand {
  max-width: 520px;
  color: #241f19;
}

.login-kicker {
  margin-bottom: 1rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.28rem;
  color: rgba(36, 31, 25, 0.55);
}

.login-title {
  margin-bottom: 1rem;
  font-size: clamp(2.5rem, 5vw, 4.9rem);
  line-height: 0.95;
  font-weight: 700;
  color: #1f1a15;
}

.login-copy {
  max-width: 28rem;
  font-size: 1.05rem;
  line-height: 1.8;
  color: rgba(36, 31, 25, 0.72);
}

.login-card {
  position: relative;
  padding: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 28px;
  background: rgba(255, 252, 247, 0.72);
  box-shadow: 0 30px 80px rgba(43, 34, 24, 0.16);
  backdrop-filter: blur(18px);
}

.login-card::before {
  content: "";
  position: absolute;
  inset: 1rem;
  border: 1px solid rgba(161, 136, 94, 0.18);
  border-radius: 20px;
  pointer-events: none;
}

.login-logo {
  display: flex;
  justify-content: center;
  margin: 0 0 1.5rem;
}

.login-brand-stack {
  margin-bottom: 1.5rem;
}

.login-client-logo {
  display: flex;
  justify-content: center;
  margin: 0 0 0.75rem;
}

.login-client-logo img {
  max-width: min(220px, 78%);
  max-height: 74px;
  object-fit: contain;
}

.login-logo img {
  width: 104px;
  height: auto;
  filter: drop-shadow(0 14px 24px rgba(56, 46, 31, 0.18));
}

.login-client-name,
.login-powered-by {
  margin: 0;
  text-align: center;
}

.login-client-name {
  font-size: 0.92rem;
  font-weight: 700;
  color: #211c17;
}

.login-powered-by {
  margin-top: 0.25rem;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.14rem;
  text-transform: uppercase;
  color: rgba(33, 28, 23, 0.52);
}

.login-card__header {
  margin-bottom: 2rem;
  text-align: center;
}

.login-card__header h2 {
  margin-bottom: 0.45rem;
  font-size: 1.8rem;
  color: #211c17;
}

.login-card__header p {
  color: rgba(33, 28, 23, 0.6);
}

.login-label {
  margin-bottom: 0.55rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  color: rgba(33, 28, 23, 0.66);
}

.login-input {
  height: 3.5rem;
  border: 1px solid rgba(120, 102, 73, 0.16);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: none;
  color: #211c17;
}

.login-input:focus {
  border-color: rgba(143, 117, 68, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(143, 117, 68, 0.12);
}

.login-input::placeholder {
  color: rgba(33, 28, 23, 0.35);
}

.login-error {
  margin: 1rem 0 1.25rem;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(148, 70, 70, 0.2);
  border-radius: 14px;
  background: rgba(185, 92, 92, 0.1);
  color: #7b3434;
  font-size: 0.92rem;
}

.login-submit {
  width: 100%;
  height: 3.5rem;
  border: 0;
  border-radius: 16px;
  background: linear-gradient(135deg, #24201b 0%, #4a3c2b 100%);
  color: #f5efe6;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.login-submit:hover,
.login-submit:focus {
  color: #f5efe6;
  transform: translateY(-1px);
  box-shadow: 0 18px 30px rgba(54, 42, 28, 0.22);
}

.login-glow {
  position: absolute;
  width: 24rem;
  height: 24rem;
  border-radius: 999px;
  filter: blur(50px);
  opacity: 0.55;
}

.login-glow-left {
  top: -6rem;
  left: -8rem;
  background: rgba(130, 102, 56, 0.16);
}

.login-glow-right {
  right: -8rem;
  bottom: -7rem;
  background: rgba(255, 255, 255, 0.28);
}

@media (max-width: 960px) {
  .login-layout {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .login-brand {
    max-width: none;
    text-align: center;
  }

  .login-copy {
    max-width: 36rem;
    margin: 0 auto;
  }
}

@media (max-width: 640px) {
  .login-shell {
    padding: 1rem;
  }

  .login-layout {
    min-height: calc(100vh - 2rem);
  }

  .login-title {
    font-size: 2.6rem;
  }

  .login-card {
    padding: 1.5rem;
    border-radius: 22px;
  }
}
</style>
